// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"175":"cb2c05fa","453":"2c3d4b62"}[chunkId] + ".chunk.js";
};